/**
 * Firebase client SDK configuration object.
 *
 * All values are read from `import.meta.env.VITE_FIREBASE_*` environment
 * variables at build time. Used by `initializeApp()` in `services/firebase.ts`.
 */
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

/** True when `VITE_ENVIRONMENT` equals `'development'`. Enables emulator connections. */
export const isDevelopment = import.meta.env.VITE_ENVIRONMENT === 'development'
/** True when `VITE_ENVIRONMENT` equals `'staging'`. */
export const isStaging = import.meta.env.VITE_ENVIRONMENT === 'staging'
/** True when `VITE_ENVIRONMENT` equals `'production'`. */
export const isProduction = import.meta.env.VITE_ENVIRONMENT === 'production'
